<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Blog Detail
        </v-card-title>
        <page-loader :loading="isFetching" />
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <input
                type="file"
                id="imagepath"
                name="imagepath"
                ref="imagepath"
                accept="image/*"
                :error-messages="errors.imagepath"
              />
            </v-col>
            <v-col sm="12">
              <v-textarea
                v-model="form.description"
                outlined
                label="Description"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.description"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn v-can:edit="'blogs'"
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "BlogDetailEditPage",
  data() {
    return {
      form: {
        is_active: false,
      },
      isLoading: false,
      isFetching: false,
    };
  },
  async mounted() {
    this.isFetching = true;
    try {
      await this.getData();
    } finally {
      this.isFetching = false;
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.blogDetailId;
      axios
        .get(`/blog_details/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios
          .patch(`/blog_details/${this.$route.params.blogDetailId}`, this.form)
          .then(async () => {
            await this.handleFileUpload();
            await this.saveUserTimestamp(this.old_json, this.form);
            this.$router.back();
          })
          .catch((error) => {
            this.isLoading = false;
            if (error.response.status != 422) {
              console.error(error);
              this.isUnAuthorised();
            }
          });
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      console.log("called");
      console.log("uploading");
      let formData = new FormData();
      formData.append("id", this.form.id);
      // imagepath
      if (this.$refs.imagepath?.files[0]) {
        this.imagepath = this.$refs.imagepath.files[0];
        formData.append("imagepath", this.imagepath);
      }
      await axios
        .post("blog_details/upload_blog_detail", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch(function (error) {
          console.log(error);
          console.log("FAILURE!!");
        });
    },
  },
};
</script>
